'use strict'

import Failed from '../../lib/Failed';

class Questionary {
    
    constructor() {
        
    }

    init (options) {
        $('input[name="' + options.name + '"]').on('click', function (e) {
            $('#btn-following').removeClass('disabled');
        });
        $('#btn-following').on('click', (e) => {
            e.preventDefault();
            this.verify(parseInt($('input[name="' + options.name + '"]:checked').val()), options);
        });
    }

    verify (value, options) {
        $('#btn-following').addClass('disabled');
        fetch(App.baseUrl + options.url, {
            method: 'POST',
            body: JSON.stringify({
                'csrf_token':$('input[name="csrf_token"]').val(),
                'value':value
            }),
            headers:{
                'Content-Type': 'application/json'
            }
        })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 0 && data.hasOwnProperty('message')){
                return Failed.show(data.message);
            }
            if (data.status === 2){
                return Failed.show(data.message);
            }
            if (data.status === 408){
                return window.location = App.baseUrl + '/panel/ingreso-email';
            }
            if (data.status === 1){
                return window.location = App.baseUrl + (data.location || options.location);
            }
        });
    }
}

export default Questionary;